export default "You are vikings preparing for a raid expedition. First of all you have to decide where you want to go. Maybe you will need help from the gods?";